'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = dragDropSourceWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function dragDropSourceWrapper(Component, dataTypeName, dragHandlerPropName) {
  var DragDropSource = function (_BcReactComponent) {
    _inherits(DragDropSource, _BcReactComponent);

    function DragDropSource() {
      _classCallCheck(this, DragDropSource);

      return _possibleConstructorReturn(this, (DragDropSource.__proto__ || Object.getPrototypeOf(DragDropSource)).apply(this, arguments));
    }

    _createClass(DragDropSource, [{
      key: 'render',
      value: function render() {
        return this.props.connectDragSource(_react2.default.createElement(
          'div',
          { className: 'cp-drag-drop-source' },
          _react2.default.createElement(Component, this.props)
        ));
      }
    }]);

    return DragDropSource;
  }(_baseBcReactComponent2.default);

  DragDropSource.propTypes = {
    // Injected by React DnD
    isDragging: _react2.default.PropTypes.bool.isRequired,
    connectDragSource: _react2.default.PropTypes.func.isRequired
  };

  var itemSource = {
    beginDrag: function beginDrag(props) {
      return props;
    },
    endDrag: function endDrag(props, monitor) {
      if (!monitor.didDrop()) {
        return;
      }

      var sourceItem = monitor.getItem();
      var targetItem = monitor.getDropResult();
      if (props[dragHandlerPropName]) {
        props[dragHandlerPropName](sourceItem, targetItem);
      }
    }
  };

  return (0, _reactDnd.DragSource)(dataTypeName, itemSource, function (connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging()
    };
  })(DragDropSource);
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drag-drop/lib/components/drag-drop-source-wrapper/components/DragDropSourceWrapper.component.js
// module id = 1184
// module chunks = 0